/* WINTERES — Universe drawer integration
   - Injects universe tabs as TOGGLES at top of drawer (no navigation)
   - On click, swaps drawer menu HTML between Outfit (default) and Shapewear (fetched via Section Rendering API)
   - On page load on Shapewear universe, auto-swaps drawer menu so desktop horizontal nav matches universe
   - On mobile (< 768px), delegates click on parent links to toggle submenu expansion.
     Wonder's native mobile toggle listeners are bound to specific DOM nodes; when we rebuild
     the drawer's innerHTML, those listeners die with the old nodes. The delegation lives on
     the drawer custom element itself (which persists across swaps), so it survives.
*/
(function () {
  'use strict';

  var SHAPEWEAR_SECTION_ID = 'winteres-shapewear-drawer';
  var outfitMenuHTML = null;
  var shapewearMenuHTML = null;
  var fetchInFlight = false;

  function detectUniverse() {
    var path = (window.location.pathname || '').replace(/\/+$/, '') || '/';
    if (path === '/pages/shapewear' || path.indexOf('/pages/shapewear/') === 0) return 'shapewear';
    if (path === '/' || path === '/pages/outfit' || path.indexOf('/pages/outfit/') === 0) return 'outfit';
    var attr = document.body && document.body.getAttribute('data-universe');
    return attr || 'outfit';
  }

  function getDrawerEl() {
    return document.querySelector('drawer-nav, .wt-drawer--nav, #wt-drawer-nav');
  }

  function getDrawerNav() {
    var d = getDrawerEl();
    return d ? d.querySelector('.wt-page-nav-mega') : null;
  }

  function updateActiveTab(universe) {
    document.querySelectorAll('.winteres-drawer-universe-tab').forEach(function (t) {
      t.classList.toggle('is-active', t.getAttribute('data-universe') === universe);
    });
  }

  function showShapewearMenu() {
    var nav = getDrawerNav();
    if (!nav) return;
    if (!outfitMenuHTML) outfitMenuHTML = nav.innerHTML;
    if (shapewearMenuHTML) {
      nav.innerHTML = shapewearMenuHTML;
      nav.setAttribute('data-winteres-swapped', 'shapewear');
      reinitMenu();
      return;
    }
    if (fetchInFlight) return;
    fetchInFlight = true;
    fetch('/?section_id=' + SHAPEWEAR_SECTION_ID, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var sectionEl = temp.querySelector('[id*="winteres-shapewear-drawer"]');
        var inner = sectionEl ? sectionEl.innerHTML : temp.innerHTML;
        shapewearMenuHTML = inner;
        var n = getDrawerNav();
        if (n) {
          n.innerHTML = inner;
          n.setAttribute('data-winteres-swapped', 'shapewear');
          reinitMenu();
        }
      })
      .catch(function (err) {
        console.warn('[winteres] failed to load shapewear menu', err);
      })
      .then(function () { fetchInFlight = false; });
  }

  function showOutfitMenu() {
    var nav = getDrawerNav();
    if (!nav || !outfitMenuHTML) return;
    nav.innerHTML = outfitMenuHTML;
    /* Mark as swapped even when restoring to outfit — Wonder's native listeners are gone
       after innerHTML rebuild, so our delegation needs to take over here too. */
    nav.setAttribute('data-winteres-swapped', 'outfit');
    reinitMenu();
  }

  function reinitMenu() {
    try { document.dispatchEvent(new Event('shopify:section:load')); } catch (e) {}
  }

  function switchUniverse(universe) {
    updateActiveTab(universe);
    if (universe === 'shapewear') showShapewearMenu(); else showOutfitMenu();
  }

  /* Mobile (<768px): event delegation for the "+" parent-item toggle.
     Bound once on the drawer custom element (persists across all innerHTML swaps).
     Only intercepts when nav has data-winteres-swapped, so initial outfit menu still
     uses Wonder's native handling untouched. Capture phase so we run before any
     leftover bubble-phase listeners. */
  function addMobileToggleDelegation() {
    var drawerEl = getDrawerEl();
    if (!drawerEl || drawerEl.__winteresMobileToggleBound) return;
    drawerEl.__winteresMobileToggleBound = true;
    drawerEl.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) return;
      var link = e.target.closest('.wt-page-nav-mega__link--parent');
      if (!link) return;
      var nav = link.closest('.wt-page-nav-mega');
      if (!nav || !nav.getAttribute('data-winteres-swapped')) return;
      e.preventDefault();
      e.stopPropagation();
      var li = link.closest('.wt-page-nav-mega__item--parent');
      if (!li) return;
      var isOpen = li.classList.toggle('winteres-mobile-open');
      link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }, true);
  }

  function injectDrawerTabs() {
    var drawer = getDrawerEl();
    if (!drawer) return;
    addMobileToggleDelegation();
    if (drawer.querySelector('.winteres-drawer-universe-tabs')) return;
    var content = drawer.querySelector('.wt-drawer__content');
    if (!content) return;
    var u = detectUniverse();
    var tabs = document.createElement('nav');
    tabs.className = 'winteres-drawer-universe-tabs';
    tabs.setAttribute('aria-label', 'Universe selection');
    tabs.innerHTML =
      '<button type="button" class="winteres-drawer-universe-tab' + (u === 'outfit' ? ' is-active' : '') + '" data-universe="outfit">Outfit</button>' +
      '<button type="button" class="winteres-drawer-universe-tab' + (u === 'shapewear' ? ' is-active' : '') + '" data-universe="shapewear">Shapewear</button>';
    content.insertBefore(tabs, content.firstChild);

    tabs.querySelectorAll('.winteres-drawer-universe-tab').forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var u = tab.getAttribute('data-universe');
        if (!u) return;
        switchUniverse(u);
      });
    });

    if (u === 'shapewear') {
      showShapewearMenu();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectDrawerTabs);
  } else {
    injectDrawerTabs();
  }
  document.addEventListener('shopify:section:load', injectDrawerTabs);
})();
